import { EntityType } from "@mapmycustomers/shared";
import FieldFeature from "@mapmycustomers/shared/enum/fieldModel/FieldFeature";
import SortOrder from "@mapmycustomers/shared/enum/SortOrder";
import IField from "@mapmycustomers/shared/types/fieldModel/IField";
import { Column } from "@mapmycustomers/shared/types/viewModel/internalModel/ColumnModel";
import ViewState from "@mapmycustomers/shared/types/viewModel/ViewState";

import Report from "@app/types/Report";
import getFieldModelByEntityType from "@app/util/fieldModel/getByEntityType";
import { isCustomField } from "@app/util/fieldModel/impl/assert";
import { createEmptyFilterModel } from "@app/util/filters/utils";
import { convertFromPlatformFilterModel } from "@app/util/viewModel/convertFromPlatformFilterModel";
import { getTaggedFilterModelForActivities } from "@app/util/viewModel/getTaggedFilterModelForActivities";

import { PREVIEW_LIMIT } from "./consts";

const isExportField = (field: IField) => !field.hasFeature(FieldFeature.NON_EXPORT_VIEW);

const getDefaultReportPreviewViewState = (report: Partial<Report>): ViewState => {
  const fieldModel = getFieldModelByEntityType(report.tableName!);
  const columns = fieldModel.fields
    .filter(isExportField)
    .map<Column>((field) => ({
      field,
      visible:
        (isCustomField(field) && report.customFields!.includes(field.customFieldData.id)) ||
        report.selectedColumns!.includes(field.exportColumnName),
    }))
    .sort(
      (column1, column2) =>
        (report.columnsOrder?.indexOf(column1.field.exportColumnName) ?? Number.MAX_SAFE_INTEGER) -
        (report.columnsOrder?.indexOf(column2.field.exportColumnName) ?? Number.MAX_SAFE_INTEGER)
    );

  const sortField = fieldModel.getByName(report.selectedOrder?.field ?? "updatedAt");
  const sortOrder = report.selectedOrder?.order ?? SortOrder.DESC;
  let filters = report.selectedFilters
    ? convertFromPlatformFilterModel(report.selectedFilters, fieldModel, isExportField)
    : createEmptyFilterModel();

  if (report.tableName === EntityType.ACTIVITY) {
    const [taggedFilterModel, incompatible] = getTaggedFilterModelForActivities(filters);
    filters = incompatible ? createEmptyFilterModel() : taggedFilterModel;
  }

  return {
    columns,
    filter: filters,
    range: { endRow: PREVIEW_LIMIT, startRow: 0 },
    selectedSavedFilterId: undefined,
    sort: sortField ? [{ field: sortField, order: sortOrder }] : [],
  };
};

export default getDefaultReportPreviewViewState;
